import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module'
import { InputLabelContainer } from '../../../../../common/components/form/label/containers/input-label.container'
import { format } from '../../../../../common/services/date.service'

export default function TenantSubscriptionInfoComponent ({tenantsDetails}: any) {
  return (
    <>
      <AccordionContainer
        child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>

                    <div>
                    <InputLabelContainer
          label="Subscription"
      />
  <InputLabelContainer
      label={tenantsDetails?.OwnerName}
  />

                    </div>
                    <div>
                    <InputLabelContainer
          label="Email"
      />
  <InputLabelContainer
      label={tenantsDetails?.Email}
  />

                    </div>
                    <div>
                    <InputLabelContainer
          label="PhoneNumber"
      />
  <InputLabelContainer
      label={tenantsDetails?.PhoneNumber}
  />

                    </div>
                    <div>
                    <InputLabelContainer
          label="Validity"
      />
  <InputLabelContainer
      label={tenantsDetails?.Validity}
  />

                    </div>
                    <div>
                    <InputLabelContainer
          label="Amount"
      />
  <InputLabelContainer
      label={tenantsDetails?.Amount}
  />

                    </div>
                    <div>
                    <InputLabelContainer
          label="Created date"
      />
  <InputLabelContainer
      label={format(tenantsDetails?.CreatedOnUtc)}
  />

                    </div>
                    <div>
                    <InputLabelContainer
          label="Modified date"
      />
  <InputLabelContainer
      label={format(tenantsDetails?.ModifiedOnUtc)}
  />
                    </div>

                    
      
        </div>
      }
        expandedPanel="Subscription Info"
        headerTitle="Subscription Info"
      />

    </>
  )
}